import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  workspaceInfo: undefined,
  usersInfo: undefined,
  licenseInfo: undefined,
  activeTab: 0,
  searchTerm: "",
};

export const userAdminSlice = createSlice({
  name: "userAdmin",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setWorkspaceInfo: (state, action) => {
      state.workspaceInfo = action.payload;
    },
    setUsersInfo: (state, action) => {
      state.usersInfo = action.payload;
    },
    setLicenseInfo: (state, action) => {
      state.licenseInfo = action.payload;
    },
  },
});

export const {
  setActiveTab,
  setSearchTerm,
  setWorkspaceInfo,
  setUsersInfo,
  setLicenseInfo,
} = userAdminSlice.actions;

export default userAdminSlice.reducer;
